import { useMemo } from "react";
import SettlementMenu from "@/components/DashSettlement/Menu";
import { DashboardRoutes } from "@/router";
import { Outlet, useLocation } from "react-router-dom";
import NavigationLayout from "@/components/NavigationLayout";
import { DetectMobileView } from "@/router/DetectMobileView";
import { Flex, Page, Space } from "@payping/web-components";
import { dashboardRoutesArray } from "@/router/constant";

const MobileSettlementWrapper = () => {
  const location = useLocation();
  const memoDashboardRoutesArray = useMemo(() => dashboardRoutesArray(), []);
  const currentUrlObj = memoDashboardRoutesArray.find((i) => i.url === location.pathname);

  const mainMenu = <SettlementMenu />;

  const subMenus = (
    <NavigationLayout
      menu={mainMenu}
      mobileBackNavigation={DashboardRoutes.settlement.root.url}
      mobileTitle={currentUrlObj?.meta.translation || ""}
    >
      <Page>
        <Space direction={"vertical"} className={"w-100 tw-gap-4 lg:tw-gap-12"}>
          <Outlet />
        </Space>
      </Page>
    </NavigationLayout>
  );

  return location.pathname === DashboardRoutes.settlement.root.url ? mainMenu : subMenus;
};

const DesktopSettlementWrapper = () => {
  const Styles = {
    PagePadding: "!tw-pl-4 !tw-pr-8",
    FlexContentWrapper: "tw-w-full tw-gap-4 xl:tw-gap-12",
  };

  return (
    <NavigationLayout menu={<SettlementMenu />}>
      <Page className={Styles.PagePadding}>
        <Flex vertical className={Styles.FlexContentWrapper}>
          <Outlet />
        </Flex>
      </Page>
    </NavigationLayout>
  );
};

const SettlementRoot = () => (
  <DetectMobileView mobile={<MobileSettlementWrapper />} desktop={<DesktopSettlementWrapper />} />
);

export default SettlementRoot;
